/* Assets */
import { ACCOUNT_GROUPS_COLLORS } from '@/assets/constants/core'
import { firstLastWordBuilder, acronymBuilder } from '@/assets/scripts/strings'
import { parseTimer } from '@/assets/scripts/dateBuilders'
/* i18n */
import i18n from '@/assets/setups/i18n'

/** returns all info provided by authentication api on login
@return { Object }
*/
export const getAllCustomerInfo = state => {
    if (!state.allUserInfo) return null
    return {
        ...state.allUserInfo,
        displayName: firstLastWordBuilder(state.allUserInfo.customer.name) || state.allUserInfo.customerInfo.msisdn
    }
}

/** returns Out Of Band Validation Type
@return { Object }
*/
export const getOutOfBandValidationType = state => { return state.outOfBandValidationType }

/** returns entity rememberMe Info
@return { Object }
*/
export const getRememberMeEntityInfo = state => { return state.rememberMeEntityInfo }

/** returns user Biometric info
@return { Object }
*/
export const getMobileBiometric = state => { return state.mobileBiometric }

/** returns user session token
@return { String }
*/
export const getToken = state => state.userSession ? state.userSession.token : null

/** returns user session token
@return { String }
*/
export const getSessionTime = state => state.userSession ? state.localExpirySpan : null

/** returns user session token
@return { String }
*/
export const getSessionTimer = state => parseTimer(state.sessionTimer)

/** return if the session is expired
@return { Boolean }
*/
export const getSessionExpiredState = state => state.sessionExpired

/** return if the session is expired
@return { Boolean }
*/
export const getSavedEntityTillOutOfBandValidation = state => state.savedEntityTillOutOfBandValidation

/** returns user session token
@return { String }
*/
export const getAccountGroups = state => {
    let colorPicker = -1

    return state.allUserInfo.accountGroups.map(account => {
        colorPicker++
        if (colorPicker === 3) colorPicker = 0

        return {
            ...account,
            title: state.allUserInfo.contractName || state.allUserInfo.customer.username,
            displayName: account.type === 'PARTICULAR' ? i18n.global.t('particularAccounts') : firstLastWordBuilder(account.name),
            displayType: account.type === 'PARTICULAR' ? i18n.global.t('particularAccounts') : i18n.global.t('companyAccounts'),
            acronym: acronymBuilder(state.allUserInfo.contractName || state.allUserInfo.customer.username),
            color: ACCOUNT_GROUPS_COLLORS[colorPicker]
        }
    })
}

/** returns if we should display popups
@return { Array }
*/
export const showPopupsList = state => state.showPopupsList

/** returns popups list
@return { Array }
*/
export const getPopupsList = state => state.popupsList
